var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllfiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2l-8 4l8 4l8 -4l-8 -4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10l8 4l8 -4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18l8 4l8 -4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14l8 4l8 -4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllfiles);
export default __webpack_public_path__ + "static/media/allfiles.08dee86d35a46b17a35a6c6316ad978f.svg";
export { ForwardRef as ReactComponent };